import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const usePowerlistDataTableStyles = makeStyles((theme: Theme) => ({
  dataTable: {
    '& .MuiDataGrid-colCellTitle': {
      whiteSpace: 'normal',
    },
    '& .MuiDataGrid-columnsContainer': {
      maxHeight: 'none !important',
      lineHeight: '26px !important',
    },
  },
  toolbarButton: {
    marginTop: '20px',
    marginBottom: '25px',
  },
  button: {
    marginTop: '30px',
    height: '50px',
    marginRight: theme.spacing(1),
  },
  disabled:
    theme.palette.mode === 'dark'
      ? {
          backgroundColor: 'grey',
          '&:hover': {
            backgroundColor: 'darkgrey',
          },
        }
      : {
          backgroundColor: 'lightgrey',
          '&:hover': {
            backgroundColor: 'grey',
          },
        },
  dropdownButton: {
    borderRadius: '0 !important',
    fontSize: 14,
    color: theme?.palette?.mode === 'dark' ? '#fff' : '#000',
    width: '100%',
    textAlign: 'left',
    padding: '5px 10px',
    '& .MuiIconButton-label': {
      display: 'block !important',
    },
  },
  flushIconButton: {
    color: 'green',
  },
  editIconButton: {
    color: theme.palette.primary.main,
  },
  deleteIconButton: {
    color: theme.custom.button.delete.main,
  },
  actionButton: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  dropdownOverflow: {
    overflow: 'visible !important',
    '.dropdown': {
      zIndex: 10,
    },
  },
  navLinkText: {
    marginLeft: 7,
  },
}));
